import PropTypes from "prop-types";
import { Grid, Icon } from "semantic-ui-react";
import { Button } from "hireart-components";

export const BillingDetails = ({
  billRate,
  canEditBillRate = false,
  onModalOpen,
  markup = "markup undetermined",
}) => {
  return (
    <Grid.Column>
      <p className="heading">{billRate}</p>
      <p>bill rate</p>
      <hr />
      <div className="card-spacer">
        {canEditBillRate ? (
          <Button
            className="termination-link is-not-padded"
            size="md"
            basic
            fluid
            onClick={onModalOpen}
          >
            Edit
            <Icon name="chevron right" className="chevron-icon" />
          </Button>
        ) : (
          <>
            <Icon name="line graph" className="chevron-icon" /> {markup}
          </>
        )}
      </div>
    </Grid.Column>
  );
};

BillingDetails.propTypes = {
  billRate: PropTypes.string.isRequired,
  canEditBillRate: PropTypes.bool,
  onModalOpen: PropTypes.func.isRequired,
  markup: PropTypes.string,
};
